// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCircleAdd = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8C17.191 8 8 17.191 8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8ZM48 33.75C48 34.9841 47.2341 35.75 46 35.75C44.9971 35.75 41.4319 34.9707 34.7887 34.7887C34.9707 41.4319 35.75 44.9971 35.75 46C35.75 47.2341 34.9841 48 33.75 48H30.25C29.0159 48 28.25 47.2341 28.25 46C28.25 44.9971 29.0293 41.4319 29.2113 34.7887C22.5681 34.9707 19.0029 35.75 18 35.75C16.7659 35.75 16 34.9841 16 33.75V30.25C16 29.0159 16.7659 28.25 18 28.25C19.0029 28.25 22.5681 29.0293 29.2113 29.2113C29.0293 22.5681 28.25 19.0029 28.25 18C28.25 16.7659 29.0159 16 30.25 16H33.75C34.9841 16 35.75 16.7659 35.75 18C35.75 19.0029 34.9707 22.5681 34.7887 29.2113C41.4319 29.0293 44.9971 28.25 46 28.25C47.2341 28.25 48 29.0159 48 30.25V33.75Z" />
    </svg>
  );
};
